import React, { useContext, useState } from "react";
import { Context } from "../../state/context";

import { ROLE_PRIVILEGE } from '../../enums/roles';
import TagsSelect from "../../components/tags-select/tags-select.component";
import useFetch from "../../api/fetch";

const defaultSelectedRole = Object.keys(ROLE_PRIVILEGE)[0];

export default function AddUserForm({ languageList }) {
    const { state, dispatch } = useContext(Context);
    const fetch = useFetch();

    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [role, setRole] = useState(defaultSelectedRole);
    const [language, setLanguage] = useState('');
    const [tags, setTags] = useState([]);
    const [newPassword, setNewPassword] = useState('');

    const handleSave = async () => {
        const tagList = tags.map((t) => {
            let mapped = {
                name: t.label
            };
            if (!t.__isNew__) {
                mapped.id = t.value;
            }

            return mapped;
        });

        const formData = new FormData();
        formData.append('username', username);
        formData.append('email', email);
        formData.append('role', role);
        formData.append('languageTag', language);
        formData.append('tags', JSON.stringify(tagList));
        formData.append('password', newPassword);

        const result = await fetch("/api/user/create", {
            method: "POST",
            body: formData
        }).then(res => res.json());

        if (result.id) {
            setUsername("");
            setEmail("");
            setRole("");
            setLanguage("");
            setTags([]);
            setNewPassword('');
            const users = [...state.users];
            users.push(result);
            dispatch({ type: 'SET_USERS', users: users });
        } else {
            alert('There was an error adding the user');
        }
    }

    return (
        <tr>
            <td>&nbsp;</td>
            <td className="align-middle">
                <input type='text' className='form-control shadow-none' placeholder='Username' onChange={(e) => { setUsername(e.target.value) }} value={username} />
            </td>
            <td className="align-middle">
                <input type='text' className='form-control shadow-none' placeholder='Email' onChange={(e) => { setEmail(e.target.value) }} value={email} />
            </td>
            <td className="align-middle">
                <select className="custom-select" onChange={(e) => { setRole(e.target.value) }} value={role}>
                    {Object.entries(ROLE_PRIVILEGE).map(([key, value], index) => (
                        <option key={index} value={key}>{key}</option>
                    ))}
                </select>
            </td>
            <td className="align-middle">
                <select className="custom-select" onChange={(e) => { setLanguage(e.target.value) }} value={language}>
                    {languageList.map((language, index) => (
                        <option key={index} value={language.tag}>{language.name}</option>
                    ))}
                </select>
            </td>
            <td className="align-middle">
                <TagsSelect selectedItems={[]} onChange={(values) => setTags(values)} />
            </td>
            <td className="align-middle">
                <input type='password' className='form-control shadow-none' placeholder={"Password"} autoComplete={'false'} onChange={(e) => { setNewPassword(e.target.value) }} value={newPassword} />
            </td>
            <td className="align-middle">
                <button className='btn btn-mondly btn-blue' onClick={handleSave}>Add user</button>
            </td>
        </tr>
    )
}